import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { CHAPTERS, OWNER_IMAGE, CONTACT } from "../../lib/siteData";

const Reveal = ({ children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="about"
      ref={ref}
      className="relative bg-[#080D0A] py-28 md:py-40"
      data-testid="manifesto-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
        <div className="md:col-span-5 md:sticky md:top-28 md:self-start">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-lime-400 font-bold">
              The Operator
            </span>
            <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl text-white mt-5 leading-none">
              Hello, Broken Arrow.
            </h2>
            <div className="relative mt-8 overflow-hidden clip-frame border border-[#223026] max-w-sm">
              <motion.img
                style={{ y: imgY, objectPosition: "32% center" }}
                src={OWNER_IMAGE}
                alt={CONTACT.owner}
                className="w-full h-[480px] object-cover scale-105 grayscale-[0.35] hover:grayscale-0 transition-[filter] duration-700"
                data-testid="owner-image"
              />
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black to-transparent">
                <p className="font-display font-bold text-white text-lg">{CONTACT.owner}</p>
                <p className="text-neutral-400 text-sm">Owner / Operator</p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-7 flex flex-col gap-16 md:pt-8">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.05}>
              <div className="relative border-l border-[#223026] pl-8 md:pl-12">
                <span className="absolute -left-2 top-0 font-display font-black text-6xl md:text-8xl text-[#111A12] leading-none select-none pointer-events-none -z-0">
                  {c.num}
                </span>
                <div className="relative z-10">
                  <span className="text-lime-400 font-mono text-sm">/ {c.num}</span>
                  <h3 className="font-display font-bold text-2xl md:text-3xl text-white mt-3 leading-tight tracking-tight">
                    {c.title}
                  </h3>
                  <p className="text-neutral-400 text-base md:text-lg leading-relaxed mt-4 max-w-xl">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
